export default __webpack_public_path__ + "static/media/signature-marife.0f322457.jpg";